/**
 * ActionTypeComingSoon — D-Q8 stub for upload/reply/form action types.
 */
export function ActionTypeComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center space-y-2">
      <p className="text-sm text-muted-foreground">
        This action type is coming soon — your project manager has been notified.
      </p>
    </div>
  );
}
